/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Info_DateInputs */



/**
* | output |
* | --- |
* | "Date" |
*
* @param {Tournament_Info_DateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_info_date = /** @type {((inputs?: Tournament_Info_DateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Info_DateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Date")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fecha")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Data")
	if (locale === "it") return /** @type {LocalizedString} */ ("Data")
	return /** @type {LocalizedString} */ ("Date")
});